<template>
    <div class="step-template">
        <div :class="`text-wrapper no-app step-${ this.appStep }`">
            <h1>Vielen Dank für Ihre Zeit</h1>

            <div class="card card-1">
                <h3>Infomaterialien und <span>Test-Account</span> anfordern</h3>

                <v-button
                    variant="primary"
                    color="green"
                    label="Mehr erfahren"
                    position="center"
                    href="/fachkreise#anchor-contact"
                />
            </div>
            <div class="card card-2">
                <h3>Alles rund um den Verschreibungsprozess</h3>

                <v-button
                    variant="primary"
                    color="green"
                    label="Mehr erfahren"
                    position="center"
                    href="/fachkreise#anchor-prescription"
                />
            </div>
            <div class="card card-3">
                <h3>Follower werden?</h3>

                <v-button
                    variant="primary"
                    color="green"
                    label="Folgen Sie uns"
                    position="center"
                    href="https://www.facebook.com/vitadio.de/"
                />
            </div>
            <div class="card card-4">
                <div class="card-wrapper">
                    <h3>Impressum</h3>

                    <div class="content-wrapper">
                        <p>Vitadio s.r.o.</p>
                        <p>Rimska 678/26, 120 00 Prag, Tschechische Republik</p>
                        <p>ID: 01892444</p>
                        <p>E-Mail für Fachkreise:</p>
                        <a href="mailto:fachkreise@vitadio.de">fachkreise@vitadio.de</a>
                        <p>Service-Hotline für Fachkreise:</p>
                        <a href="tel:+4901631349009">0163 1349009</a>
                    </div>
                </div>

                <v-button
                    variant="primary"
                    color="green"
                    label="Rufen Sie uns an"
                    position="center"
                    href="/kontakt?business"
                />
            </div>

            <div class="shadow-wrapper">
                <figure class="shadow">
                    <picture>
                        <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
                    </picture>
                </figure>
                <figure class="shadow">
                    <picture>
                        <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
                    </picture>
                </figure>
                <figure class="shadow">
                    <picture>
                        <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
                    </picture>
                </figure>
                <figure class="shadow">
                    <picture>
                        <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
                    </picture>
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {},
    data(){
        return {
            appStep: 26
        }
    },
}

</script>

